import {
  XCircleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/20/solid';

export const ALERT_TYPE = {
  SUCCESS: {
    type: 'SUCCESS',
    backgroundStyling: 'bg-green-50',
    headerTextStyling: 'text-green-800',
    descriptionTextStyling: 'text-green-700',
    icon: (
      <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
    ),
  },
  WARNING: {
    type: 'WARNING',
    backgroundStyling: 'bg-yellow-50',
    headerTextStyling: 'text-yellow-800',
    descriptionTextStyling: 'text-yellow-700',
    icon: (
      <ExclamationTriangleIcon
        className="h-5 w-5 text-yellow-400"
        aria-hidden="true"
      />
    ),
  },
  ERROR: {
    type: 'ERROR',
    backgroundStyling: 'bg-red-50',
    headerTextStyling: 'text-red-800',
    descriptionTextStyling: 'text-red-700',
    icon: <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />,
  },
  INFORMATION: {
    type: 'INFORMATION',
    backgroundStyling: 'bg-blue-50',
    headerTextStyling: 'text-blue-800',
    descriptionTextStyling: 'text-blue-700',
    icon: (
      <InformationCircleIcon
        className="h-5 w-5 text-blue-400"
        aria-hidden="true"
      />
    ),
  },
};

const Alert = ({ alertType, alertHeader, alertDescription }) => {
  const { backgroundStyling, headerTextStyling, descriptionTextStyling } =
    ALERT_TYPE[alertType];

  return (
    <div className={`rounded-md p-2 ${backgroundStyling}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          {alertType === ALERT_TYPE.SUCCESS.type && ALERT_TYPE.SUCCESS.icon}
          {alertType === ALERT_TYPE.INFORMATION.type &&
            ALERT_TYPE.INFORMATION.icon}
          {alertType === ALERT_TYPE.WARNING.type && ALERT_TYPE.WARNING.icon}
          {alertType === ALERT_TYPE.ERROR.type && ALERT_TYPE.ERROR.icon}
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium ${headerTextStyling}`}>
            {alertHeader}
          </h3>
          <div className={`mt-2 text-sm ${descriptionTextStyling}`}>
            <p>{alertDescription}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alert;
